import type { SVGProps } from 'react'
const SvgSyChatPlus1 = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M20 12c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 4 14.8 4 12 4s-4.2 0-5.27.545A5 5 0 0 0 4.545 6.73C4 7.8 4 9.2 4 12v6c0 .943 0 1.414.293 1.707S5.057 20 6 20h6c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12"
		/>
		<path d="M8.5 12a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm9-12a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5" />
		<path d="M14.5 6a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
	</svg>
)
export default SvgSyChatPlus1
